"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;

var _Search = _interopRequireDefault(require("./Search"));

exports.default = _Search.default;


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/dist/commonjs/modules/Search/index.js
// module id = 1520
// module chunks = 0